import React, { memo } from 'react';
import './Tab.css';

const Tab = memo(({ 
  id, 
  label, 
  isActive, 
  onClick, 
  disabled = false,
  className = '' 
}) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick(id);
    }
  };

  return (
    <button
      className={`tab ${isActive ? 'tab--active' : ''} ${disabled ? 'tab--disabled' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      role="tab"
      aria-selected={isActive}
    >
      {label}
    </button>
  );
});

Tab.displayName = 'Tab';

export default Tab;
